import Global from '../mixins/Global.js'
import VueScrollTo from 'vue-scrollto';
import vClickOutside from 'v-click-outside'
import moment from 'moment';

export default {
    mixins: [Global],

    data() {
        return {
            user: user,
            closing_media_dropdown: false,
            media_visible: false,
            editing_content: false,
            previous_content: '',
        }
    },

    methods: {
        showNewest() {
            if (this.newestItem) {
                //get the item
                let item = this.newestItem;
                let id = item.id;
                let plural = item.plural;

                let options = {
                    offset: -300
                };

                //set the highlight variable of the item to true
                this.$store.commit('highlightFeedItem', {item: item});

                //scroll towards it
                this.$scrollTo('#post-' + id, 500, options);

                //hide the 'show newest' button
                this.itemHighlighted = true;
                document.removeEventListener(`scroll`, this.scrollHandler);

                this.focusCommentByHashId = false;
            }
        },

        contentFilter(item, checkAuth, limit) {
            let content = '';
            const self = this;

            if(checkAuth) {
                if(this.settings.show_topic_preview === "1") {
                    content = item['excerpt'];
                }

                //if user has read permissions, we have access to the content
                if(item.permissions.includes('READ')) {
                    content = item['content'];
                }
            } else {
                content = item['content'];
            }

            let iframeRegex = /(<iframe(.*?src=["']([^"]+)["'])(.*?)<\/iframe>)/g; //html chars
            let iframeRegex2 = /(&lt;iframe(.*?src=["']([^"]+)["'])(.*?)&lt;\/iframe&gt;)/g; //unicode chars
            let hrefRegex = /(<a href=["']([^"]+)["']([^<]+))/g;
            let urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig; //possibly improved one (made for flutter package): /(\b(?:(?:(?:https?|ftp|file):\/\/)|(?:wwww?\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
            let urlExcludes = [];

            if(!iframeRegex.test(content) && limit) {
                // because a mention has quite a lot of "length", i.e. what comes out as @maartjedaems will initially look
                // like <a href=""><span class="data-mention"><span>@username</span></span></a> etc
                // so to ignore the length of the html which the user doesn't see, we create an html element
                // from the initial content, then get its innerText to just get the plaintext
                let div = document.createElement('div');
                div.innerHTML = content;

                // then we increase the limit by the amount of html that we determined is in the string
                limit = limit + (content.length - div.innerText.length);

                // if the content extends the preview limit
                if (content.length > limit) {
                    // grab the text that is within the limits bounds
                    content = content.substr(0, limit);

                    // cut the last word of so we always finish on a full word
                    if (content.indexOf(' ') !== -1) {
                        content = content.substr(0, Math.min(content.length, content.lastIndexOf(' ')));
                    }
                }
            }

            //find all html iframes, paste their src intro urlExcludes
            content = content.replace(iframeRegex, function () {
                urlExcludes.push(Array.prototype.slice.call(arguments)[3]);
                return Array.prototype.slice.call(arguments)[1];
            });

            //find all unicode iframes, paste their src intro urlExcludes and replace unicodes with HTML
            content = content.replace(iframeRegex2, function () {
                urlExcludes.push(Array.prototype.slice.call(arguments)[3]);

                let new_iframe_code = Array.prototype.slice.call(arguments)[1];
                new_iframe_code = '<' + new_iframe_code.slice(4);
                new_iframe_code = new_iframe_code.slice(0, -19) + '></iframe>';

                return new_iframe_code;
            });

            //find all <a hrefs>, paste their src into urlExcludes
            content = content.replace(hrefRegex, function () {
                urlExcludes.push(Array.prototype.slice.call(arguments)[2]);
                return Array.prototype.slice.call(arguments)[1];
            });

            content = content.replace(urlRegex, function (url) {
                // linkify links if the URL is not found by the previous regexes
                // and if we're displaying an excerpt which is shorter than the full content
                // and the link isnt broken by just displaying an excerpt (which results in https://goo instead of https://google.com)
                if(urlExcludes.join().indexOf(url) === -1 && url.indexOf('https://media.tenor.com') === -1) {
                    if(url.replace('http://','').replace('https://','').split('/')[0] !== location.href.replace('http://','').replace('https://','').split('/')[0]) {
                        return '<a class="secondary-c" target="_blank" href="' + url + '">' + url + '</a>';
                    } else {
                        return '<a class="secondary-c" href="' + url + '">' + url + '</a>';
                    }
                } else {
                    return url;
                }
            });

            return content.replaceAll(/>https:\/\/link\.thehuddle.nl\/.*?\//gmi, function (url) {
                // if the link goes to the homepage, i.e. https://huddle.local, the first / found by the regex will be of </a>
                // we don't want to replace the '</' portion of this as it will break the link
                // so in that case we add '</' to the end to keep it from breaking
                if (url.slice(-2) === '</') {
                    return '>' + self.$settings('domain') + '/</';
                }

                return '>' + self.$settings('domain') + '/';
            });

            // return content.replaceAll(/>https:\/\/link\.thehuddle.nl\/.*?\//gmi, '>' + this.$settings('domain') + '/');
        },

        submitEditItem(payload) {
            let self = this;
            let item = payload.custom_data.item;
            let content = payload.content;
            let conversationId = -1;


            if(item.objType === 'Comment') {
                conversationId = item.topic().id;
            } else if(item.objType === 'Reply') {
                conversationId = item.comment().topic().id;
            }

            if(conversationId !== -1) {
                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Comment',
                            crud_method: 'update',
                            sub_path: '/comments/' + item.id,
                            save_data: {
                                'conversation[id]': conversationId,
                                id: item.id,
                                'content': content,
                            },
                            success_callback: function (response) {
                                success_callback(response);
                            },

                            failure_callback: function (response) {
                                failure_callback(response);
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updateFeedItem', {content: content, item: item});
                    self.$store.commit('toggleSpinner', false);
                    self.closeEditing();
                };

                let failure_callback = function (response) {
                    self.$store.commit('toggleSpinner', false);
                };
            }
        },

        likePost(payload) {
            let self = this;

            if(!this.user.impersonating && this.user && !payload.closed) {
                self.$store.commit('toggleSpinner', true);

                let id = payload.id;
                let model = payload.model;
                let modelSingular = pluralize.singular(model);

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: modelSingular,
                            crud_method: 'update',
                            custom_verb: 'post',
                            sub_path: '/likes/like/',
                            save_data: {id: id},
                            //save_data: {id: topic.id, title: this.modalData.title}
                            //save_data: topic.getDataForSave(),
                            success_callback: function (response) {
                                success_callback(response);
                            },
                            failure_callback: function (response) {
                                failure_callback(response);
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updatePostLike', payload);
                    self.$store.commit('toggleSpinner', false);
                };

                let failure_callback = function (response) {
                    self.$store.commit('toggleSpinner', false);
                };
            }
        },

        setEditing(bool, edit_obj, content_field_name = 'content') {
            // store previous content so we can revert it on escape
            if (bool === true) {
                this.previous_content = edit_obj[content_field_name];
            } else {
                edit_obj[content_field_name] = this.previous_content;
            }

            this.editing_content = bool;
        },

        closeEditing() {
            this.editing_content = false;
        },

        initEditTopic(topic, reload_after_edit = false) {
            let self = this;

            //set topic data for editing
            let editTopicData = {
                title: topic.title,
                content: topic.content,
                id: topic.id,
                topContent: this.translations['forum.edit_topic'],
                icon: 'fa fa-pencil',
                activeBoard: '',
                activeSubboard: '',
                boardType: topic.board_type,
                topicType: topic.post_type,
                videoUrl: topic.video_url,
                isIntroductionTopic: false,
                metaTitle: topic.meta_title,
                metaDescription: topic.meta_description,
                slug: topic.slug,
                release_date: topic.release_date,
            };

            //set currently active board
            if (topic.subboard()) {
                editTopicData.activeBoard = topic.subboard().board();
                editTopicData.activeSubboard = topic.subboard();
            } else {
                editTopicData.activeBoard = topic.board();
                editTopicData.activeSubboard = '';
            }

            if(topic.post_type === 'introduce') {
                editTopicData.isIntroductionTopic = true;
            }

            //set edit topic modal data
            this.$store.commit('setModalData', {
                modalName: 'EditTopic',
                modalData: editTopicData,

                modalSubmitEmit() {
                    let channel = 0;
                    let release_date = topic.release_date;

                    if (this.modalData.activeBoard.id === this.modalData.activeSubboard.id || this.modalData.activeSubboard === '') {
                        channel = this.modalData.activeBoard;
                    } else {
                        channel = this.modalData.activeSubboard;
                    }

                    if(this.modalData.release_date) {
                        release_date = moment(this.modalData.release_date).format('DD-MM-YYYY HH:mm');
                    }

                    this.$store.dispatch(
                        {
                            type: 'activeDataAction',
                            data: {
                                model: 'Topic',
                                crud_method: 'update',
                                sub_path: '/comments/' + topic.post_id,
                                save_data: {
                                    'conversation[id]': topic.id,
                                    id: topic.post_id,
                                    'content': this.modalData.content,
                                    'title': this.modalData.title,
                                    'video_url': this.modalData.videoRegexed,
                                    channel_id: channel.id,
                                    'meta_title': this.modalData.metaTitle,
                                    'meta_description': this.modalData.metaDescription,
                                    'slug': this.modalData.slug,
                                    'conversation[release_date]': release_date,
                                },
                                success_callback: function (response) {
                                    if(response.success === false){
                                        failure_callback(response);
                                    }
                                    success_callback(channel, response)
                                },
                                failure_callback: function (response) {
                                    failure_callback(response);
                                }
                            }
                        }
                    );

                    let success_callback = function (channel) {
                        self.$store.commit('updateTopic', {
                            topic: topic,
                            title: editTopicData.title,
                            content: editTopicData.content,
                            videoRegexed: editTopicData.videoRegexed,
                            channel_id: channel.id,
                            metaTitle: editTopicData.metaTitle,
                            metaDescription: editTopicData.metaDescription,
                            slug: editTopicData.slug,
                            reload_page: reload_after_edit,
                            release_date: release_date,
                        });

                        self.$store.commit('toggleSpinner', false);
                    };

                    let failure_callback = function (response) {
                        //self.$store.commit('setErrorMessage', response.message);
                        //self.$store.commit('showBottomError', true);
                        self.$store.commit('toggleSpinner', false);
                    };
                }
            });
        },

        //show the media dropdown
        openMediaDropdown() {
            setTimeout(() => {
                if(!this.closing_media_dropdown) {
                    this.media_visible = !this.media_visible;
                }
            }, 0);
        },

        //hide the media dropdown
        closeMediaDropdown() {
            if(this.media_visible) {
                this.media_visible = false;

                //we temporarily disable the openMediaDropdown function or else we run into issues with v-click-outside
                this.closing_media_dropdown = true;

                setTimeout(() => {
                    this.closing_media_dropdown = false;
                }, 0);
            }
        }
    },

    filters: {
        getDateHumanFormat: function (date) {
            //previous page fix, in case vue is loaded before the plugins are
            if (typeof (moment) !== "undefined") {
                return moment(date).fromNow();
            }

            return date;
        }
    },

    directives: {
        clickOutside: vClickOutside.directive
    }
}
